import { render, staticRenderFns } from "./Imprimir.vue?vue&type=template&id=356b9e4a&scoped=true&lang=pug&"
import script from "./Imprimir.vue?vue&type=script&lang=js&"
export * from "./Imprimir.vue?vue&type=script&lang=js&"
import style0 from "./Imprimir.vue?vue&type=style&index=0&id=356b9e4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b9e4a",
  null
  
)

export default component.exports